import {
    GenericItemsUtils,
    Grid,
    IGetAllParams,
    GenericItemsForm,
    BaseGenericItemsStore,
    MuiDataGrid,
    MuiIcons,
    Toc as TocIcon
} from "@leap4/frontend";
import {IAdServer} from "@leap4/entities-discrepancy-common"
import {adServersBaseUrl} from "../../../config/generals";
import {urlService} from "../../routing/urlsService"
import {RootState} from "../../../interfaces/root-state.interface";
import {connect, ConnectedProps} from "react-redux";
import {Server} from "@leap4/auth";
import React from "react";
import {OneOrgOnly} from "../../shared/OneOrgOnly/OneOrgOnly";

type GridColDef = MuiDataGrid.GridColDef;

const fields = {
    name: 1,
    created: 1,
    updated: 1,
    isActive: 1,
    overview: 1
}
const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});


const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const getParams: IGetAllParams = {
    fields,
}

let columns: GridColDef[];
let store: BaseGenericItemsStore<IAdServer & { _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: adServersBaseUrl,
    }, fields, {
        name: {editLinkFunc: (id: string) => urlService.editAdServer(id)},
        isActive: {},
        updated: {},
        created: {},
        // overview: {overviewLinkFunc: (id: string) => urlService.adServerOverview(id)}
    })

    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
}

const AdServersModule = (props:PropsFromRedux) => {
    setStoreAndColumns();
    const lastChosenOrganization = localStorage.getItem(Server.headers.X_ORGANZIZATION).split('-')
    if (lastChosenOrganization.length > 1) {
        return <OneOrgOnly />
    }
    return (
        <GenericItemsForm
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.adServers(),
                text: "Ad-Servers Dashboard",
                icon: <TocIcon />
            }}
            getAllParams={getParams}
            organization={props.selectedOrganization}
            createButton={{
                to: urlService.createAdServer(),
                text: "create Ad-Server ".toUpperCase()
            }}

        tableProps={{pageSize:50}}/>
    );
};


export default connector(AdServersModule);